
import {  Link } from "react-router-dom"
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import {SVCDFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd'

const _ = require('lodash')
const React = require('react')
const {connect}  = require("react-redux")



const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}


const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  /*
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )
*/
let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }


let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
      let s = null;
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
       
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
        if(!formData.address){
            errors.address= 'Required'
        }
        if(!formData.city){
            errors.city= 'Required'
        }
        if(!formData.state){
            errors.state= 'Required'
        }
        if(!formData.zip){
            errors.zip= 'Required'
        }
        if(!formData.country){
            errors.country= 'Required'
        }
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
       
        if(!formData.cardCvv){
            errors.cardCvv= 'Required'
        }
        if(!formData.cardExpMonth){
            errors.cardExpMonth= 'Required'
        }else{
            s = formData.cardExpMonth
           if (s.trim().length !=2){
            errors.cardExpMonth= '2 digit like 28 for 2028'
           }
        }
        if(!formData.cardExpYear){
            errors.cardExpYear= 'Required'
        }else{
             s = formData.cardExpYear
            if (s.trim().length !=2){
             errors.cardExpYear= '2 digit like 01 for Jan, 12 for December'
            }
         }
        if(!formData.cardNumber){
            errors.cardNumber= 'Required'
        }else{
            s = formData.cardNumber
           if (s.trim().length < 6){
            errors.cardNumber= 'Min 6 alphanum like 88881222'
           }
        }
        if(!formData.phone){
            errors.phone= 'Required'
        }
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class CreateStoredcardFormFormBus extends React.Component{

    constructor(props){
        
        super(props)
        let me = this
        this.loadGene = this.loadGene.bind(this)
        this.ddChange = this.ddChange.bind(this) 
        this.cancelPage = this.cancelPage.bind(this) 
      //  this.dcountryChange = this.dcountryChange.bind(this)
        this.getAppDetails = this.getAppDetails.bind(me)
       
    }
    

    getAppDetails(paramQSpaceId){
        //for edit we have id make it -1 for create

        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        console.log("id* addressr det or cerate ******", id)
       //loadAddressDet(id)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    cancelPage(){
        console.log('cancel page')

    }
 loadGene(e){
        console.log(e)
    }

/*
    dcountryChange(e){

        console.log(e)
        console.log('gene name:' +this.props.dcountry)

        let o = _.findWhere(dcountries,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             dcountry:o.name
        })

    }
    */
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    
    render(){
        console.log('sv... SVCDnaStepFormBus')
        
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
       // const { id, gene} = initialValues
       
        /*svj31 start*/
    const {countryTypes,countryTwoTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
    /*svj31 end*/
       const me = this 
        //me.gene = gene
        let initialValues = this.props.initialValues

        console.log(this.props)

        const {det} = this.props
        
        if(det && det.phone.length > 0){
            initialValues = det
        }
        let {customerId} = det
        console.log('sv(***CreateStoredCard form initialValue**')
        console.log(initialValues)

        return (
            <div>
                    <form  onSubmit={handleSubmit}>
                            <div className="rev-row">
                                <div className="card card--raised with-shadow">
                                    <p className="right-sd-content"> <text> Enter Details Now </text></p>

                                       
                                        {/*  
                                         <div className="form-group">
                                            <label htmlFor="id"> ID</label>
                                            
                                                <Field
                                            
                                                id="id"
                                                    name="id"
                                                    type="text"
                                                    placeholder="id"
                                                    component="input"
                                                    className="form-control"
                                                />
                                            

                                        </div> 
                                        <div className="form-group">
                                            <label htmlFor="id"> Card ID</label>
                                            
                                                <Field
                                            
                                                id="cardId"
                                                    name="cardId"
                                                    type="text"
                                                    placeholder="id"
                                                    component="input"
                                                    className="form-control"
                                                />
                                            

                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="id"> Customer ID</label>
                                            
                                                <Field
                                            
                                                id="customerId"
                                                    name="customerId"
                                                    type="text"
                                                    placeholder="id"
                                                    component="input"
                                                    className="form-control"
                                                />
                                            

                                        </div>
                                        */}
                                        <div className="form-group">
                                            <label htmlFor="name"> Full Name As on Card</label>
                                            <Field
                                                    id="name"
                                                    name="name"
                                                    type="text"
                                                    placeholder="James Watt"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fname"> Card Number</label>
                                            
                                                <Field
                                            
                                                    id="cardNumber"
                                                    name="cardNumber"
                                                    type="text"
                                                    placeholder="1113412341234123"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fname"> Card CVV</label>
                                            
                                                <Field
                                            
                                                    id="cardCvv"
                                                    name="cardCvv"
                                                    type="text"
                                                    placeholder="123"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fname"> Expiry Month</label>
                                            
                                                <Field
                                            
                                                    id="cardExpMonth"
                                                    name="cardExpMonth"
                                                    type="text"
                                                    placeholder="03"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fname"> Expiry Year</label>
                                            
                                                <Field
                                            
                                                    id="cardExpYear"
                                                    name="cardExpYear"
                                                    type="text"
                                                    placeholder="27"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="gene"> Card -Zip Code</label>
                                            <Field
                                                    id="zip"
                                                    name="zip"
                                                    type="text"
                                                    placeholder="95648"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                         {/*  
                                        <div className="form-group">
                                        
                                            <label htmlFor="dcountry"> Card -CountryA3 </label>
                                            <Field id="dcountry"  name="dcountry" onChange={me.dcountryChange} component="select">

                                                <option  value="">Select Country</option>
                                                {
                                                    dcountries.map ((o, idx)=>{

                                                        return ( <option  value={o.value}>{o.name}</option>)
                                                    })
                                                }

                                            </Field>

                                        </div>
                                         */}
                                        <div className="form-group">
                                                <label htmlFor="country" > Country</label>
                                                <Field  component="select" id="country"   name="country"  className="form-control" >
                                                
                                                    <option value="">Select Country</option>
                                                    {
                                        
                                                
                                        countryTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>

                        </div>
                        <div className="form-group">
                                            <label htmlFor="phone"> Phone</label>
                                            <Field
                                                    id="phone"
                                                    name="phone"
                                                    type="text"
                                                    placeholder="916-645-6360"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                        </div>
                        <div className="form-group">
                                                <label htmlFor="isdcode" > ISD Code (Card Billing Address)</label>
                                                <Field  component="select" id="isdcode"   name="isdcode"  className="form-control" >
                                                
                                                <option value="">Select PhoneCalling /ISD Code</option>
                                                    {
                                        
                                                
                                        isdcodeTypes.map(  (o, idx)=>(  <option value={o.name+'('+o.value+')'} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                         </div>
                                       <h3>Card Billing Address</h3>

                                        <div className="form-group">
                                            <label htmlFor="fname"> First Name</label>
                                            
                                                <Field
                                            
                                                    id="fname"
                                                    name="fname"
                                                    type="text"
                                                    placeholder="John"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="lname"> Last Name</label>
                                            <Field
                                                    id="lname"
                                                    name="lname"
                                                    type="text"
                                                    placeholder="Glen"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email"> Email Address</label>
                                            <Field
                                                    id="email"
                                                    name="email"
                                                    type="text"
                                                    placeholder="john123@yahoo.com"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="address"> Address </label>
                                            <Field
                                                    id="address"
                                                    name="address"
                                                    type="text"
                                                    placeholder="790 J St, Lincoln"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="city"> City</label>
                                            <Field
                                                    id="city"
                                                    name="city"
                                                    type="text"
                                                    placeholder="Lincoln"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        
                                       
                                        {/* 
                                        
                                           <div className="form-group">
                                            <label htmlFor="isdcode"> ISD Code</label>
                                            <Field
                                                    id="isdcode"
                                                    name="isdcode"
                                                    type="text"
                                                    placeholder="+1"
                                                    component="input"
                                                    className="form-control"
                                            />
                                        </div>
                                        */}
                                       
                                     
                                      
                                    </div>
                            </div>

                            <div>
        
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${customerId}/mystoredcardList`}> SVCancel   </Link></SVAButton>
        
               <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
          Save(CreateOrModify)
        </button>   
         </div>
                    </form>
            </div>
        )
                    
                    

    }
}



const selector = formValueSelector(SVCDFORM)
/*
let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
  */

const cdForm  = reduxForm({
    form:SVCDFORM,
    validate:validate,
   
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(CreateStoredcardFormFormBus)
let CreateStoredcardFormFormBusCom =connect((state=>{
    const { svstoredcarddetView} = state
    let plucked = state.movies  
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:svstoredcarddetView.my_data_storedcarddet}
    console.log('sv*******************CrateAddressForm shoul getmy_data_storedcarddet start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_storedcarddet end ')
    
    return o
   // return plucked.adData
}),{
    //load:loadAdAction,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(cdForm)


export default CreateStoredcardFormFormBusCom
//const CreateStoredcardFormFormBusCom  =x